import React from 'react';

// Footer component that displays the copyright information with the current year. It takes a prop 'singleSurvey' to determine the styling of the footer based on whether it's being used in a single survey view or not.
const Footer = ({singleSurvey}) =>
    {
        const currentYear = new Date().getFullYear();

            return (
                <div className='container-fluid p-0 m-0 footer-banner'>
                    <div className={singleSurvey === false ? 'copyright text-center p-2' : 'copyright-single-survey text-center p-2'}>
                        <h2 className={singleSurvey === false ? 'copyright-heading text-white' : 'copyright-heading-single-survey'}>&copy;{currentYear} PORTAL</h2>
                    </div>
                </div>
        
            );     
    }
    
    export default Footer;